import * as React from "react";
import Svg, { Rect, G, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Rect width={42} height={42} rx={4.2} fill="#F3FAF6" />
    <G clipPath="url(#clip0_1201_8397)">
      <Path
        opacity={0.2}
        d="M20.4463 19.8552C22.3103 19.8552 23.8213 18.3442 23.8213 16.4802C23.8213 14.6163 22.3103 13.1052 20.4463 13.1052C18.5823 13.1052 17.0713 14.6163 17.0713 16.4802C17.0713 18.3442 18.5823 19.8552 20.4463 19.8552Z"
        fill="#0E8741"
      />
      <Path
        opacity={0.2}
        d="M26.0713 28.8552C27.9353 28.8552 29.4463 27.3442 29.4463 25.4802C29.4463 23.6163 27.9353 22.1052 26.0713 22.1052C24.2073 22.1052 22.6963 23.6163 22.6963 25.4802C22.6963 27.3442 24.2073 28.8552 26.0713 28.8552Z"
        fill="#0E8741"
      />
      <Path
        opacity={0.2}
        d="M14.8213 28.8552C16.6853 28.8552 18.1963 27.3442 18.1963 25.4802C18.1963 23.6163 16.6853 22.1052 14.8213 22.1052C12.9573 22.1052 11.4463 23.6163 11.4463 25.4802C11.4463 27.3442 12.9573 28.8552 14.8213 28.8552Z"
        fill="#0E8741"
      />
      <Path
        d="M20.4463 19.8552C22.3103 19.8552 23.8213 18.3442 23.8213 16.4802C23.8213 14.6163 22.3103 13.1052 20.4463 13.1052C18.5823 13.1052 17.0713 14.6163 17.0713 16.4802C17.0713 18.3442 18.5823 19.8552 20.4463 19.8552Z"
        stroke="#0E8741"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M26.0713 28.8552C27.9353 28.8552 29.4463 27.3442 29.4463 25.4802C29.4463 23.6163 27.9353 22.1052 26.0713 22.1052C24.2073 22.1052 22.6963 23.6163 22.6963 25.4802C22.6963 27.3442 24.2073 28.8552 26.0713 28.8552Z"
        stroke="#0E8741"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14.8213 28.8552C16.6853 28.8552 18.1963 27.3442 18.1963 25.4802C18.1963 23.6163 16.6853 22.1052 14.8213 22.1052C12.9573 22.1052 11.4463 23.6163 11.4463 25.4802C11.4463 27.3442 12.9573 28.8552 14.8213 28.8552Z"
        stroke="#0E8741"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1201_8397">
        <Rect
          width={24}
          height={24}
          fill="white"
          transform="translate(8.44629 9.35522)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
